import { Box, BoxProps } from '@mui/material';
import React from 'react';

const FlexBox: React.FC<BoxProps> = ({ children, ...props }) => (
    <Box display="flex" {...props}>
        {children}
    </Box>
);

export default FlexBox;
